import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../redux/actions";

const useIsAuth = () => {
  const auth = useSelector((state) => state.auth);
  const authLocal = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  const isOpenLink =
    window.location.href.search("id") !== -1 &&
    window.location.href.search("share") !== -1;

  useEffect(() => {
    if (!auth.user?._id && authLocal?._id) {
      const authLocal = JSON.parse(localStorage.getItem("user"));
      dispatch(authActions.login(authLocal));
    }
  }, []);

  if (isOpenLink) {
    return true;
  }

  if (auth.user?._id || authLocal?._id) {
    return true;
  }

  return false;
};

export default useIsAuth;
